export default {
  LOAD_CURRENT_ENVIRONMENT (state, payload) {
    state.currentEnvironment = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/learningContent/vuex/mutations.js